import { atom } from "jotai";
import { getAllAccountRoots } from "../../services/AccountRoot/service";
import { AccountRootResponse } from "../../types/models";

export const accountRootsAtom = atom<AccountRootResponse[]>([]);

export const fetchAccountRootsAtom = atom(null, async (get, set) => {
  if (get(accountRootsAtom).length > 0) return;

  try {
    const roots = await getAllAccountRoots();
    set(accountRootsAtom, roots);
  } catch (error) {
    console.error("Failed to fetch account roots:", error);
    set(accountRootsAtom, []);
  }
});
